import { atom } from 'jotai';
import { PHENOMENON_GROUP_IDS, UNIT_IDS } from 'utils/constsLtool';

export const matrixTabAtom = atom<number>(0);

type Status = 'notstarted' | 'loading' | 'success' | 'error';

export const loadingAtom = atom<boolean>(false);

export type AchievementDeviationEntry = {
    // BE の値域は "OK" / "WARNING" / "NG" / null（未計算）。未知の値は utils/assessment の resolver が色なしにする。
    assessment: string | null;
    deviation_max: number | null;
};

export type AchievementCategoryMap = Record<string, AchievementDeviationEntry>;

// 達成度判断表 GET のレスポンス。BEV / HEV とも unit > condition の 2 階層
// （HEV は URL の gear 分だけが返る）。risk_margin は判定に使われた現象グループ別のマージン（dB）で、
// 取得前・欠落に備えて optional にする。
export type AchievementLevelData = {
    message: string;
    risk_margin?: Record<string, number>;
    achievement_level: Record<string, AchievementCategoryMap>;
};

export const achievementLevelAtom = atom<{ data: AchievementLevelData; status: Status }>({
    data: {
        message: "",
        achievement_level: {},
    },
    status: "notstarted",
});

export type SelectedUnitId = typeof UNIT_IDS[number];

export const unitIdAtom = atom<SelectedUnitId>(UNIT_IDS[0]);

export type SelectedPhenomenonGroupId = typeof PHENOMENON_GROUP_IDS[number];

export const phenomenonGroupIdAtom = atom<SelectedPhenomenonGroupId>(PHENOMENON_GROUP_IDS[0]);

// 個別グラフ表示のx軸。周波数(index)は各グラフの描画基準軸のため常時表示、
// RPM/車速は補助的な目盛り行の表示・非表示をユーザーが選択できる。
export type SupplementaryXAxisKind = 'rpm' | 'vel';

export const visibleSupplementaryXAxesAtom = atom<SupplementaryXAxisKind[]>(['rpm', 'vel']);
